import React, { useState } from 'react';
import supabase from '../../supabase/supabase';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function AddUserModal({ onClose, onSuccess }) {
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { data, error: authError } = await supabase.auth.signUp({
        email,
        password,
      });

      if (authError) throw authError;

      if (data?.user) {
        // Update the profile with Name and Role
        const { error: profileError } = await supabase
          .from('profiles_20240520')
          .update({ 
            full_name: fullName,
            role: role 
          })
          .eq('id', data.user.id);
        
        if (profileError) console.error("Error setting profile details:", profileError);
        onSuccess();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[70] p-4 backdrop-blur-sm">
      <div className="bg-app-surface border border-app-border rounded-xl w-full max-w-md shadow-2xl overflow-hidden">
        <div className="p-6 border-b border-app-border flex justify-between items-center">
          <h2 className="text-xl font-bold flex items-center gap-2 text-white">
            <SafeIcon icon={FiIcons.FiUserPlus} className="text-app-accent" />
            Add New User
          </h2>
          <button onClick={onClose} className="text-app-muted hover:text-white"><FiIcons.FiX size={24}/></button>
        </div>

        <form onSubmit={handleAdd} className="p-6 space-y-4">
          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-app-muted">Full Name</label>
            <input 
              type="text" 
              required
              value={fullName}
              onChange={e => setFullName(e.target.value)}
              className="w-full bg-app-bg"
              placeholder="John Doe"
            />
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-app-muted">Email Address</label>
            <input 
              type="email" 
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full bg-app-bg"
              placeholder="trader@terminal.com"
            />
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-app-muted">Temporary Password</label>
            <input 
              type="password" 
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full bg-app-bg"
              placeholder="••••••••"
            />
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-app-muted">Assigned Role</label>
            <select 
              value={role}
              onChange={e => setRole(e.target.value)}
              className="w-full bg-app-bg"
            >
              <option value="user">Standard Trader</option>
              <option value="admin">Platform Admin</option>
            </select>
          </div>

          {error && (
            <div className="p-3 bg-app-red/10 border border-app-red/20 rounded text-app-red text-xs">
              {error}
            </div>
          )}

          <div className="pt-4 flex gap-3">
            <button 
              type="button" 
              onClick={onClose}
              className="flex-1 py-3 text-sm font-bold border border-app-border rounded-lg hover:bg-app-border transition-colors text-white"
            >
              Cancel
            </button>
            <button 
              type="submit"
              disabled={loading}
              className="flex-1 py-3 text-sm font-bold bg-app-accent text-black rounded-lg hover:bg-yellow-500 transition-colors flex items-center justify-center gap-2"
            >
              {loading ? <FiIcons.FiLoader className="animate-spin" /> : <FiIcons.FiCheckCircle />}
              Create User
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}